/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown>, total: NonNullable<unknown>, width: NonNullable<unknown>, height: NonNullable<unknown> }} Image_Export_Magnified_Event_HintInputs */

const en_image_export_magnified_event_hint = /** @type {(inputs: Image_Export_Magnified_Event_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} of ${i?.total} | ${i?.width}x${i?.height}`)
};

const fr_image_export_magnified_event_hint = /** @type {(inputs: Image_Export_Magnified_Event_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evenement ${i?.index} sur ${i?.total} | ${i?.width}x${i?.height}`)
};

const de_image_export_magnified_event_hint = /** @type {(inputs: Image_Export_Magnified_Event_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ereignis ${i?.index} von ${i?.total} | ${i?.width}x${i?.height}`)
};

const it_image_export_magnified_event_hint = /** @type {(inputs: Image_Export_Magnified_Event_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evento ${i?.index} di ${i?.total} | ${i?.width}x${i?.height}`)
};

const ru_image_export_magnified_event_hint = /** @type {(inputs: Image_Export_Magnified_Event_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Событие ${i?.index} из ${i?.total} | ${i?.width}x${i?.height}`)
};

const es_image_export_magnified_event_hint = /** @type {(inputs: Image_Export_Magnified_Event_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evento ${i?.index} de ${i?.total} | ${i?.width}x${i?.height}`)
};

const zh_cn2_image_export_magnified_event_hint = /** @type {(inputs: Image_Export_Magnified_Event_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`事件 ${i?.index} 的 ${i?.total} | ${i?.width}x${i?.height}`)
};

const ja_image_export_magnified_event_hint = /** @type {(inputs: Image_Export_Magnified_Event_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント ${i?.index} / ${i?.total} | ${i?.width}x${i?.height}`)
};

const hi_image_export_magnified_event_hint = /** @type {(inputs: Image_Export_Magnified_Event_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} की घटना ${i?.index} | ${i?.width}x${i?.height}`)
};

const pt_pt2_image_export_magnified_event_hint = /** @type {(inputs: Image_Export_Magnified_Event_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evento ${i?.index} de ${i?.total} | ${i?.width}x${i?.height}`)
};

/**
* | output |
* | --- |
* | "Event {index} of {total} \| {width}x{height}" |
*
* @param {Image_Export_Magnified_Event_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_magnified_event_hint = /** @type {((inputs: Image_Export_Magnified_Event_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Magnified_Event_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_magnified_event_hint(inputs)
	if (locale === "de") return de_image_export_magnified_event_hint(inputs)
	if (locale === "it") return it_image_export_magnified_event_hint(inputs)
	if (locale === "ru") return ru_image_export_magnified_event_hint(inputs)
	if (locale === "es") return es_image_export_magnified_event_hint(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_magnified_event_hint(inputs)
	if (locale === "ja") return ja_image_export_magnified_event_hint(inputs)
	if (locale === "hi") return hi_image_export_magnified_event_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_magnified_event_hint(inputs)
	return en_image_export_magnified_event_hint(inputs)
});